<!-- 监测指标数据跟踪 -->
<template>
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <div class="chart_box page-box">
        <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
        <input id="completeNum" v-model="completeNum" v-show="false" />
        <div class="header_titles">
          <h1>职业教育“{{ header.zykName }}”专业教学资源库({{ header.zykNum }})</h1>
          <h1 style="margin-top: 15px">监测指标数据跟踪分析报告</h1>
          <div class="number_time">
            <div>
              <span>主持单位：{{ header.allHostUnit }}</span>
              <span>分析时间：{{ header.time }}</span>
            </div>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="table-box">
          <table v-if="detailData.declBuildBaseInfo">
            <tr class="tr-head">
              <td colspan="3">一、资源库基本信息</td>
            </tr>
            <tr>
              <td>当前级别</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.projectType }}</td>
            </tr>
            <tr>
              <td>上线时长（学期）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.standardCourseTime }}</td>
            </tr>
            <tr>
              <td>接入国家职业教育智慧教育平台</td>
              <td colspan="2">
                {{ detailData.joinCountryPlatform }}
                <!-- <el-radio-group v-model="detailData.joinCountryPlatform">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group> -->
              </td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">二、资源建设与应用情况</td>
            </tr>
            <tr>
              <td>资源总量</td>
              <td colspan="2">{{ detailData.resourceBuild.resourceCount }}</td>
            </tr>
            <tr>
              <td>文本类/图形图像</td>
              <td>{{ detailData.resourceBuild.textVo.sumValue }}</td>
              <td>{{ detailData.resourceBuild.textVo.percentage }}</td>
            </tr>
            <tr>
              <td>文本型演示文稿（ppt、网页课件与富媒体等）</td>
              <td>{{ detailData.resourceBuild.textPPTVo.sumValue }}</td>
              <td>{{ detailData.resourceBuild.textPPTVo.percentage }}</td>
            </tr>
            <tr>
              <td>动画类</td>
              <td>{{ detailData.resourceBuild.animationVo.sumValue }}</td>
              <td>{{ detailData.resourceBuild.animationVo.percentage }}</td>
            </tr>
            <tr>
              <td>虚拟仿真类</td>
              <td>{{ detailData.resourceBuild.virtualVo.sumValue }}</td>
              <td>{{ detailData.resourceBuild.virtualVo.percentage }}</td>
            </tr>
            <tr>
              <td>音频类</td>
              <td>{{ detailData.resourceBuild.audioVo.sumValue }}</td>
              <td>{{ detailData.resourceBuild.audioVo.percentage }}</td>
            </tr>
            <tr>
              <td>视频类</td>
              <td>{{ detailData.resourceBuild.videoVo.sumValue }}</td>
              <td>{{ detailData.resourceBuild.videoVo.percentage }}</td>
            </tr>
            <tr>
              <td>微课类</td>
              <td>{{ detailData.resourceBuild.smallCourseVo.sumValue }}</td>
              <td>{{ detailData.resourceBuild.smallCourseVo.percentage }}</td>
            </tr>
            <tr>
              <td>其他</td>
              <td>{{ detailData.resourceBuild.otherVo.sumValue }}</td>
              <td>{{ detailData.resourceBuild.otherVo.percentage }}</td>
            </tr>
            <tr>
              <td>原创资源占比</td>
              <td colspan="2">{{ detailData.resourceBuild.originVo.percentage }}</td>
            </tr>
            <tr>
              <td>资源被课程引用的占比</td>
              <td colspan="2">{{ detailData.resourceBuild.courseResourceVo.percentage }}</td>
            </tr>
            <tr>
              <td>资源内容存储总量（GB）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.resourceSave }}</td>
            </tr>
            <tr>
              <td>文本型演示文稿、图形（像）类和文本类资源量（GB）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.textImage }}</td>
            </tr>
            <tr>
              <td>专业人才培养方案（份）</td>
              <td colspan="2">
                {{ detailData.professionTrain }}
                <!-- <el-input v-model="detailData.professionTrain" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>标准化课程的知识图谱（份）</td>
              <td colspan="2">
                {{ detailData.standardCourseAtlas }}
                <!-- <el-input v-model="detailData.standardCourseAtlas" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>课程教学标准或规范（份）</td>
              <td colspan="2">
                {{ detailData.courseTeachStandard }}
                <!-- <el-input v-model="detailData.courseTeachStandard" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>资源访问总量</td>
              <td colspan="2">{{ detailData.resourceBuild.resourceVisit }}</td>
            </tr>
            <tr>
              <td>无活动资源数</td>
              <td colspan="2">{{ detailData.resourceBuild.noActiveResource }}</td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">三、课程建设与应用情况</td>
            </tr>
            <tr>
              <td>课程总数（门）</td>
              <td colspan="2">
                {{
                  +detailData.declBuildBaseInfo.standardNum +
                  +detailData.declBuildBaseInfo.majorCoreNum
                }}
              </td>
            </tr>
            <tr>
              <td>标准化课程（门）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.standardNum }}</td>
            </tr>
            <tr>
              <td>专业核心课程（门）</td>
              <td colspan="2">
                {{ detailData.declBuildBaseInfo.majorCoreNum }}
                <!-- <el-input v-model="detailData.declBuildBaseInfo.majorCoreNum" placeholder="请输入" size="small" /> -->
              </td>
            </tr>
            <tr>
              <td>标准化课程选课总人数（人）</td>
              <td colspan="2">{{ detailData.standardCourseRegNum }}</td>
            </tr>
            <tr>
              <td>无访问标准化课程数（门）</td>
              <td colspan="2">{{ detailData.noActiveStandardNum }}</td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">四、题库建设与应用情况</td>
            </tr>
            <tr>
              <td>题库总数</td>
              <td colspan="2">{{ detailData.questionCount }}</td>
            </tr>
            <tr>
              <td>主观题</td>
              <td colspan="2">{{ detailData.objectiveQ }}</td>
            </tr>
            <tr>
              <td>客观题</td>
              <td colspan="2">{{ detailData.subjectivityQ }}</td>
            </tr>
            <tr>
              <td>题库使用率（%）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.questionBankUseRate }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="chart_box page-box">
        <div class="table-box">
          <table v-if="detailData.declBuildBaseInfo">
            <tr class="tr-head">
              <td colspan="3">五、整体应用推广情况</td>
            </tr>
            <tr>
              <td>访问总量（次）</td>
              <td colspan="2">{{ detailData.userVisitNum }}</td>
            </tr>
            <tr>
              <td>用户总数（人）</td>
              <td colspan="2">{{ userTotal }}</td>
            </tr>
            <tr v-for="(item, index) in userTypeArr" :key="index">
              <td>{{ item.name }}总数（人）</td>
              <td colspan="2">{{ item.value }}</td>
            </tr>
            <tr>
              <td>主持单位核心专业与服务专业教师合计人数（人）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.chargeCoreTeacher }}</td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.chargeCoreRealNameTeacher }}</td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ detailData.chargeNoAccessTeacher }}</td>
            </tr>
            <tr>
              <td>主持单位核心专业与服务专业学生合计人数（人）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.chargeCoreStudent }}</td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.chargeCoreRealNameStudent }}</td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ detailData.chargeNoAccessStudent }}</td>
            </tr>
            <tr>
              <td>参与单位核心专业与服务专业教师合计人数（人）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.pitchCoreTeacher }}</td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.pitchRealNameTeacher }}</td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ detailData.buildSchoolNoAccessTeacher }}</td>
            </tr>
            <tr>
              <td>参与单位核心专业与服务专业学生合计人数（人）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.pitchCoreStudent }}</td>
            </tr>
            <tr>
              <td>其中：实名注册合计人数（人）</td>
              <td colspan="2">{{ detailData.declBuildBaseInfo.pitchRealNameStudent }}</td>
            </tr>
            <tr>
              <td>其中：实名注册无活动人数（人）</td>
              <td colspan="2">{{ detailData.buildSchoolNoAccessTeacher }}</td>
            </tr>
            <tr class="tr-head">
              <td colspan="3">六、年度更新情况</td>
            </tr>
            <tr>
              <td>本年度新增资源数（条）</td>
              <td colspan="2">
                {{ detailData.yearResourceAdd[detailData.yearResourceAdd.length - 1].num }}
              </td>
            </tr>
            <tr>
              <td>本年度资源更新率</td>
              <td colspan="2">
                {{ detailData.yearUpdateRate[detailData.yearUpdateRate.length - 1].num }}
              </td>
            </tr>
            <tr>
              <td>本年度资源内容存储增量（GB）</td>
              <td colspan="2">{{ detailData.yearResourceSpaceAddNum }}</td>
            </tr>
            <tr>
              <td>本年度新增用户数（人）</td>
              <td colspan="2">{{ +detailData.yearTeacherAdd + +detailData.yearStudentAdd }}</td>
            </tr>
            <tr>
              <td>其中：新增教师数（人）</td>
              <td colspan="2">{{ detailData.yearTeacherAdd }}</td>
            </tr>
            <tr>
              <td>其中：新增学生数（人）</td>
              <td colspan="2">{{ detailData.yearStudentAdd }}</td>
            </tr>
            <tr>
              <td>本年度新增用户占比</td>
              <td colspan="2">{{ detailData.thisYearAddPercentage }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pageToPDF from "@/utils/htmlToPdf.js";
export default {
  data() {
    return {
      completeNum: 0, //统计接口数量
      header: {},
      detailData: {},
      userTypeArr: [], // 整体应用推广情况用户类别
      userTotal: 0, // 整体应用推广情况用户总数
    };
  },
  created() {
    this.header = this.$route.query;
    this.dataChange(this.header.zykId);
  },
  watch: {
    completeNum(val) {
      console.log(val);
    },
  },
  methods: {
    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      pageToPDF(
        `${this.header.zykNum}_${this.header.zykName}_监测指标数据跟踪分析报告`,
        this.$refs.pdfContent,
        lableList
      );
    },
    dataChange(e) {
      this.$axios
        .post(this.$apiurls.major_switch, e, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.getInfo();
            this.getDeclBuildBaseInfo();
          }
        });
    },
    // 年度基本信息
    getInfo() {
      this.$axios
        .post(this.$apiurls.report_yaer_getZykInformationVo, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.header = { ...this.header, ...res.data };
            this.header.allHostUnit = this.header.allHostUnit.replaceAll(",", "，");
            this.completeNum = this.completeNum + 1;
          }
        });
    },
    // 获取表格数据
    getDeclBuildBaseInfo() {
      this.$axios
        .post(this.$apiurls.getDeclBuildBaseInfo, {
          zykId: this.header.zykId,
          endTime: this.header.time,
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.detailData = res.data;
            this.userTypeArr = res.data.userTypeNum.filter((item) => item.name !== "其他");
            let sum = 0;
            this.userTypeArr.forEach((item) => {
              sum += item.value;
            });
            this.userTotal = sum;
            this.completeNum = this.completeNum + 1;
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-box {
  table {
    width: 100%;
    margin-bottom: 1px;
    table-layout: fixed;
    border-collapse: collapse;
    font-size: 25px;

    tr {
      td {
        // height: 55px;
        padding: 10px 30px;
        text-align: center;
        border: 1px solid #ddd;

        ::v-deep .el-input__inner {
          height: 28px;
          width: 200px;
          border-color: #ddd;
          color: #e6a23c;
        }
      }
    }

    .tr-head {
      font-weight: bold;

      td:first-child {
        text-align: left;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
* {
  margin: 0px;
  padding: 0px;
}
.export {
  position: absolute;
  right: 0.625rem;
  top: 0.625rem;
  z-index: 1;
  min-width: 88px;
  height: 40px;
}
.analysisReport {
  position: relative;
  width: 100%;
  background: #fff;

  .analysisReport_box {
    // width: 86.7%;
    // margin: 0px auto;
    // height: 5480px; //28

    .page-box {
      // padding: 7% 0;
      // height: 2740px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;

      // border: 1px solid red;
      .m-top150 {
        margin-top: 150px;
      }

      .header_titles {
        display: flex;
        justify-content: center;
        flex-flow: column;
        color: #000;
        text-align: center;
        position: relative;
        font-size: 40px;

        h1 {
          font-size: 55px;
          font-weight: bold;
          color: #1d244e;
        }

        .monthly {
          font-size: 40px;
          font-weight: 400;
          color: #1d244e;
          line-height: 30px;
          margin-top: 6px;
        }
      }

      .number_time {
        margin: 30px 0;

        div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #707f9d;
          font-size: 25px;
        }

        p {
          width: 100%;
          height: 1px;
          background: #707f9d;
          margin-top: 8px;

          &:last-child {
            opacity: 0.5;
            margin-top: 4px;
          }
        }
      }

      // 一级标题
      .division {
        font-weight: bold;
        font-size: 44px;
        color: #1d244e;
        margin: 35px 0;
      }

      h3,
      h4,
      h5,
      h6 {
        font-weight: 700;
        color: #1d244e;
        margin-top: 30px;
        margin-bottom: 35px;
      }

      h3 {
        font-size: 50px;
      }

      h4 {
        font-size: 42px;
      }

      h5 {
        font-size: 40px;
      }

      h6 {
        font-size: 39px;
      }

      p {
        font-weight: 540;
        font-size: 35px;
        text-indent: 2em;
        line-height: 70px;
        color: #272a3f;
      }

      .chart_name {
        font-weight: 540;
        text-align: center;
        font-size: 32px;
        color: #272a3f;
        margin-top: 20px;
      }

      .notes {
        margin: 35px 0;
        line-height: 50px;
        font-size: 30px;
        color: black;
      }

      .biaoge {
        font-weight: 540 !important;
        width: 98%;
        color: #272a3f !important;
        margin: 25px auto;

        .course {
          text-align: center;

          tr {
            height: 45px;
            line-height: 45px;
            color: #707f9d;
            font-size: 22px;

            &:nth-child(2n) {
              background: rgba(11, 201, 212, 0.2);
              color: #566178;
            }

            &:nth-child(2n-1) {
              background: rgba(73, 187, 233);
              color: #566178;
            }
          }

          .th_tr {
            background: rgb(88, 136, 248);
            color: #fff;
          }
        }
      }

      .echartsHeight {
        height: calc(100vw / 1080 * 300);
        margin: 10px auto 0px;
      }
    }

    // 首页样式
    .HomePage {
      padding-left: 10%;

      #image {
        width: 700px;
        height: 150px;
        background: url("../../../../public/pdf.png") no-repeat;
        background-size: 100% 100%;
      }

      #PdfTitle {
        padding: 20px 0px 20px 40px;
        border-left: 3px solid #729ac0;

        #FristTitle {
          font-size: 65px;
          font-weight: 700;
          margin-bottom: 40px;
        }

        #SecondTitle {
          font-size: 65px;
          font-weight: 600;
          margin-bottom: 40px;
        }

        .ThrendTitle {
          font-size: 50px;
          font-weight: 600;
          margin-bottom: 40px;
        }

        #FourTitle {
          font-size: 50px;
          font-weight: 700;
          margin-bottom: 40px;
        }
      }

      #foot {
        display: flex;

        .footBox {
          flex-direction: column;
          display: flex;
          align-items: center;
          font-size: 42px;
          margin-left: 4.5%;

          p {
            margin: 20px 0px;
          }
        }
      }
    }

    // 目录样式
    .catalogue {
      padding: 10% 8%;

      .title {
        text-align: center;
        margin-bottom: 4%;
        font-size: 40px;
      }

      h5 {
        margin-top: 50px;
        margin-bottom: 15px;
        line-height: 40px;
        display: flex;
        align-items: center;
        font-size: 45px;

        .dot {
          flex: 1;
          border-top: dotted #1d244e 7px;
          margin: 0 10px;
        }
      }

      .Second_text {
        padding-left: 1.8em;
      }

      .Thred_text {
        padding-left: 7.69em;
      }
    }

    // 弹性盒子
    .flex-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }

  .export {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}

::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}
</style>
